import React from 'react';
/* --- import Components ----*/
import { CTAContainer, CTAInfoContent } from './elements';
import { TagContainerCenter } from '../Tags/elements';
import Tag from '../Tags/Tag';
import { Section, TwoColumns } from '../Section';
import { SectionTitle, TitleDescription, UppercaseWords, CTASectionSubtitle } from '../Typography';
import { AnchorButton } from '../Button';
/* --- import Utils ----*/
import { SessionDateDisplay, nextSessionsFilter } from 'src/utils/helpers';
/* --- import Styles and Images ----*/
import colors from 'src/style/colors';
import { mediaQueries } from 'src/style/breakpoints';
import { useMediaQueries } from 'src/utils/MediaQueries';
import { RocketIllustration } from './index';
import { StarsCTAFooter } from '../Illustrations';
import sizes from 'src/style/sizes';

const CTACourses = React.memo(({ nextSessions }) => {
  const mqs = useMediaQueries();

  const nextFullTimeSession = SessionDateDisplay(
    nextSessionsFilter(nextSessions, 'formation-developpeur-web-mobile')[0],
    'Temps Plein'
  );
  const nextPartTimeSession = SessionDateDisplay(
    nextSessionsFilter(nextSessions, 'formation-developpeur-web-mobile-temps-partiel')[0],
    'Temps Partiel'
  );
  const nextAlternanceSession = SessionDateDisplay(
    nextSessionsFilter(nextSessions, 'formation-developpeur-web-mobile')[0],
    'Alternance'
  );
  const nextElearningSession = SessionDateDisplay(
    nextSessionsFilter(nextSessions, 'formation-developpeur-web-et-web-mobile')[0],
    'E-Learning'
  );

  return (
    <Section theme="primary">
      <CTAContainer>
        <RocketIllustration />
        <StarsCTAFooter />
        <CTAInfoContent>
          <SectionTitle
            isCenter
            css={{
              paddingBottom: 100,
              paddingTop: 16,
              [mediaQueries.phoneOnly]: {
                paddingBottom: 64,
              },
            }}
          >
            Prêt à devenir <br />
            un.e super développeur.se ? <br />
            {/* Web et Mobile ? */}
          </SectionTitle>
          <section
            css={{
              paddingBottom: 100,
              [mediaQueries.phoneOnly]: {
                paddingBottom: 64,
              },
            }}
          >
            <TwoColumns
              sizeLeft={sizes.columnWidth.medium}
              left={
                <div>
                  <UppercaseWords>Prochaine Session</UppercaseWords>
                  <TitleDescription>Formation Développeur Web et Mobile (Bac+3/4)</TitleDescription>
                  <TagContainerCenter>
                    <Tag home color="purpleDark" spacer>
                      {'Temps plein'}
                    </Tag>
                    <Tag home color="yellow" spacer>
                      {'10 semaines'}
                    </Tag>
                  </TagContainerCenter>
                  <div
                    css={{
                      paddingTop: 16,
                      paddingBottom: 32,
                    }}
                  >
                    <CTASectionSubtitle css={{ color: colors.yellow }}>
                      {nextFullTimeSession}
                    </CTASectionSubtitle>{' '}
                  </div>

                  <AnchorButton to="/bootcamp-javascript/formation-developpeur-web-mobile/">
                    En savoir plus
                  </AnchorButton>

                  <div
                    css={{
                      height: 30,
                      [mediaQueries.tabletLandscapeUp]: {
                        display: 'none',
                      },
                    }}
                  />
                </div>
              }
              sizeRight={sizes.columnWidth.medium}
              right={
                <div>
                  <UppercaseWords>Prochaine Session</UppercaseWords>
                  <TitleDescription>Formation Développeur Web et Mobile (Bac+3/4)</TitleDescription>
                  <TagContainerCenter>
                    <Tag home color="purpleDark" spacer>
                      {'Temps partiel'}
                    </Tag>
                    <Tag home color="yellow" spacer>
                      {'6 mois'}
                    </Tag>
                  </TagContainerCenter>
                  <div css={{ paddingTop: 16, paddingBottom: 32 }}>
                    <CTASectionSubtitle
                      css={{ color: colors.yellow, paddingTop: 20, paddingBottom: 40 }}
                    >
                      {nextPartTimeSession}
                    </CTASectionSubtitle>
                  </div>

                  <AnchorButton to="/bootcamp-javascript/formation-developpeur-web-mobile-temps-partiel/">
                    En savoir plus
                  </AnchorButton>
                </div>
              }
            />
          </section>
          <section>
            <TwoColumns
              sizeLeft={sizes.columnWidth.medium}
              left={
                <div>
                  <UppercaseWords>Prochaine Session</UppercaseWords>
                  <TitleDescription>Formation Développeur Web et Mobile (Bac+3/4)</TitleDescription>
                  <TagContainerCenter>
                    <Tag home color="purpleDark" spacer>
                      {'Alternance'}
                    </Tag>
                    <Tag home color="yellow" spacer>
                      {'15 à 17 mois'}
                    </Tag>
                  </TagContainerCenter>
                  <div
                    css={{
                      paddingTop: 16,
                      paddingBottom: 32,
                    }}
                  >
                    <CTASectionSubtitle css={{ color: colors.yellow }}>
                      {nextAlternanceSession}
                    </CTASectionSubtitle>{' '}
                  </div>

                  <AnchorButton to="/formation-alternance/concepteur-developpeur-applications/">
                    En savoir plus
                  </AnchorButton>

                  <div
                    css={{
                      height: 30,
                      [mediaQueries.tabletLandscapeUp]: {
                        display: 'none',
                      },
                    }}
                  />
                </div>
              }
              sizeRight={sizes.columnWidth.medium}
              right={
                <div>
                  <UppercaseWords>Prochaine Session</UppercaseWords>
                  <TitleDescription>
                    Formation Développeur Web {mqs.tabletLandscapeUp ? <br /> : ''}(Bac+2)
                  </TitleDescription>
                  <TagContainerCenter>
                    <Tag home color="purpleDark" spacer>
                      {'E-Learning'}
                    </Tag>
                    <Tag home color="yellow" spacer>
                      {'3 à 6 mois'}
                    </Tag>
                  </TagContainerCenter>
                  <div css={{ paddingTop: 16, paddingBottom: 32 }}>
                    <CTASectionSubtitle
                      css={{ color: colors.yellow, paddingTop: 20, paddingBottom: 40 }}
                    >
                      {nextElearningSession}
                    </CTASectionSubtitle>
                  </div>

                  <AnchorButton to="/cours-informatique/formation-developpeur-web/">
                    En savoir plus
                  </AnchorButton>
                </div>
              }
            />
          </section>
        </CTAInfoContent>
      </CTAContainer>
    </Section>
  );
});
export default CTACourses;
